import pkg from '../../package.json' with { type: 'json' }
import { uuid } from '../shared/uuid'
import type {
  EventInput,
  LoomductConfig,
  LoomductEvent,
  PropertyValue,
} from './types'
import { stripLinkUrl, stripPageUrl } from './url'

function stripOrDrop(value: string | undefined): string | undefined {
  try {
    return value ? stripLinkUrl(value).slice(0, 2000) : undefined
  } catch {
    return undefined
  }
}

export function buildEvent(
  input: EventInput,
  referrer: string | undefined,
  config: Pick<LoomductConfig, 'hashRouting' | 'urlParams'>,
): LoomductEvent {
  const { properties, ...fields } = input
  const event: LoomductEvent = {
    id: uuid(),
    url: location.href,
    title: document.title,
    screen: { width: screen.width, height: screen.height },
    viewport: { width: innerWidth, height: innerHeight },
    language: navigator.language,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    lib: { name: '@loomduct/js', version: pkg.version },
    referrer,
    ...fields,
  }
  event.url = stripPageUrl(event.url, config).slice(0, 2000)
  event.referrer = stripOrDrop(event.referrer)
  event.target = stripOrDrop(event.target)
  if (event.engagementMs !== undefined) {
    event.engagementMs = Math.min(
      86_400_000,
      Math.max(0, Math.round(event.engagementMs)),
    )
  }
  if (properties) {
    event.properties = Object.fromEntries(
      Object.entries(properties).filter(
        (entry): entry is [string, PropertyValue] => entry[1] !== undefined,
      ),
    )
  }
  return event
}
